export default {
  friends: {
    title: '友達',
    subtitle: '友達関係を管理',
    addFriend: '友達を追加',
    noFriends: 'まだ友達がいません',
    addFriendsHint: '友達を追加して一緒に経費を共有しましょう！',
    unknownUser: '不明なユーザー',
    removeFriend: '友達を削除',
    confirmRemove: '友達を削除しますか？',
    removeSuccess: '友達の削除に成功しました',
    removedFriend: '{name} を友達から削除しました',
    
    // タグ
    tagsUpdated: '友達のタグが正常に更新されました',
    allFriends: 'すべて',
    noTaggedFriends: '「{tag}」タグを持つ友達はいません',
    tryOtherTags: '他のタグを選択するか、新しい友達を追加してください',
    
    // 読み込み状態
    loading: {
      title: '友達を接続中...',
      subtitle: '友達情報を読み込んでいます',
    },
    // タグエディター
    editTags: '友達のタグを編集',
    selectedTags: '選択したタグ',
    presetTags: 'プリセットタグ',
    myTags: 'マイタグ',
    addCustomTag: 'カスタムタグを追加',
    tagInputPlaceholder: 'タグ名を入力（例：ジム仲間）',
    tagHelp: 'タグのヘルプ',
    tagAlreadyExists: 'このタグはすでに存在します',
    tagSaveSuccess: '友達のタグが正常に更新されました',
    tagSaveError: '保存に失敗しました',
    saving: '保存中...',
    save: '保存',
    noTagsSelected: 'タグが選択されていません',
    success: '成功',
    error: 'エラー',
    tagHelpText: `• タグは友達を分類して管理するのに役立ちます
• グループ食事を作成する際にタグで招待者を素早く選択できます
• 1人の友達に複数のタグを設定できます
• 短く明確なタグ名を使用することをお勧めします`,
    
    // プリセットタグの翻訳
    presetTagCoworker: '同僚',
    presetTagClassmate: 'クラスメート', 
    presetTagNeighbor: '近隣',
    presetTagRoommate: 'ルームメイト',
    presetTagFamily: '家族',
    presetTagGymBuddy: 'ジム仲間',
    presetTagGameBuddy: 'ゲーム仲間',
    presetTagLunchBuddy: 'ランチ仲間',
    presetTagTravelBuddy: '旅行仲間',
    presetTagStudyBuddy: '勉強仲間',
    presetTagWorkPartner: '仕事のパートナー',
    
    // 検索と追加
    contactLabel: '連絡先情報',
    contactPlaceholder: 'メール、ユーザー名、または電話番号を入力',
    searchPlaceholder: 'ユーザー名、メール、または電話を検索',
    searchEmpty: 'ユーザーが見つかりませんでした',
    searchError: '検索に失敗しました。後でもう一度お試しください',
    searchHint: 'より正確な検索結果を得るために完全な情報を入力してください',
    searching: '検索中...',
    searchResults: '検索結果',
    addByContact: '連絡先情報で追加',
    scanQRCode: 'QRコードをスキャンして追加',
    shareMyQR: 'マイQRコードを共有',
    sendRequest: '友達リクエストを送信',
    
    // 友達リクエストメッセージ
    messageLabel: '友達リクエストメッセージ（任意）',
    messagePlaceholder: '自己紹介を記載すると、友達リクエストが受け入れられやすくなります',
    
    // ステータスメッセージ
    loadFailed: '友達リストの読み込みに失敗しました',
    searchFailed: '検索に失敗しました',
    incompleteUserInfo: 'ユーザー情報が不完全です',
    enterContactInfo: 'メール、ユーザー名、または電話番号を入力してください',
    requestSent: '友達リクエストを正常に送信しました！',
    requestFailed: '友達リクエストの送信に失敗しました',
    removeFailed: '友達の削除に失敗しました',
  }
};